<template>
    <div>
        <q-dialog
            v-model="modal"
            transition-show="scale"
            transition-hide="scale"
            :maximized="$q.platform.is.mobile"
        >
            <q-card class="modal-testimonial">
                <div class="modal-header">
                    <div class="modal-close" @click="modal=false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10"
                                 enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill=""
                                      d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                    <div class="modal-tab">
                        <div :class="{ active: is('review') }" @click.prevent="openFeedbackModal('review')"><span>Оставить отзыв</span></div>
                        <div :class="{ active: is('question') }" @click.prevent="openFeedbackModal('question')"><span>Задать вопрос</span></div>
                    </div>
                </div>
                <review :id="id" v-if="is('review')" @submitted="showAlert"></review>
                <question :id="id" v-if="is('question')" @submitted="showAlert"></question>
            </q-card>
        </q-dialog>

        <q-dialog v-model="alert" persistent transition-show="scale" transition-hide="scale">
            <q-card class="modal-testimonial-done">
                <div class="modal-close" @click="alert=false">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             x="0px" y="0px" width="10px"
                             height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
                <q-card-section class="modal-content">
                    <div v-if="responseHeader" class="testimonial-done-header">{{ responseHeader }}</div>
                    <span class="text">{{ responseMessage }}</span>
                    <q-card-actions align="left" class="q-pa-none">
                        <q-btn square outlined color="primary" label="Хорошо" @click.prevent="close()"/>
                    </q-card-actions>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import Review from './Feedback/Review.vue';
    import Question from './Feedback/Question.vue';

    export default {
        name: 'ProductFeedback',
        components: {
            review: Review,
            question: Question,
        },
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data () {
            return {
                alert: false,
                responseHeader: '',
                responseMessage: ''
            }
        },
        methods: {
            ...mapMutations('product', [
                'openFeedbackModal',
                'hideFeedbackModal',
            ]),

            is (form) {
                return this.feedbackModal === form;
            },

            showAlert (message, header) {
                this.responseMessage = message;
                this.responseHeader = header;

                this.alert = true;
            },

            close () {
                this.alert = false;

                this.responseMessage = '';

                this.hideFeedbackModal();
            }
        },
        computed: {
            ...mapState('product', [
                'feedbackModal',
            ]),

            modal: {
                get() {
                    return this.feedbackModal !== null;
                },

                set(value) {
                    this.hideFeedbackModal();
                }
            },
        }
    }
</script>
